module.exports = __webpack_public_path__ + "img/ro.625aca9e.svg";